import React from 'react';
import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';
import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';
import StyledEducationImage from './educationImage.style';
import EducationShape from '../shape/educationShape';

const Image = dynamic(() => import(/* webpackChunkName: "image" */ '../../image/image'));

const EducationImage = ({
  image,
  corner = '40px',
  category,
  contentType,
  titleClass = '',
  ...props
}) => {
  return (
    <StyledEducationImage {...props} corner={corner}>
      {!image && contentType && contentType.length === 1 && (
        <div className="category-image__title-container">
          <Headline className={`category-image__title ${titleClass}`} tag="span">
            {contentType[0].title}
          </Headline>
        </div>
      )}
      <EducationShape
        className="category-image"
        clippedClass="category-image__clip"
        category={category}
        contentType={contentType}
      >
        {image && <Image className="category-image__src" {...image} lazy="default" />}
      </EducationShape>

      {image?.caption && (
        <Copy tag="div" small dangerouslySetInnerHTML={{ __html: image.caption }} />
      )}
      {image?.credits && (
        <Copy tag="div" small dangerouslySetInnerHTML={{ __html: image.credits }} />
      )}
    </StyledEducationImage>
  );
};

EducationImage.propTypes = {
  image: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
    caption: PropTypes.string,
    credits: PropTypes.string
  }),
  corner: PropTypes.string,
  titleClass: PropTypes.string,
  contentType: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired,
  category: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired
    })
  ).isRequired
};

export default EducationImage;
